export default __webpack_public_path__ + "static/media/404.30f2ef40.jpeg";